import { isMobile } from '../helpers/isMobile';
import { slotBarSymbolNames, slotSpineKey } from './symbolsNames';

// RU: ассеты разложены по платформе одинаково — `.../<web|mobile>/...`, поэтому список один,
//     а платформа — его аргумент.
export const platformFolder = () => (isMobile() ? 'mobile' : 'web');

// RU: спайн — json и atlas с одним путём.
const spineResource = (name, path) => ({
  name,
  path: `${path}.json`,
  config: {
    metadata: {
      spineAtlasFile: `${path}.atlas`,
      imageNamePrefix: '_',
    },
  },
});

// RU: атлас TexturePacker и его KTX2-версия рядом. У этой игры JSON атласов без `meta.image`
//     (собран под KTX2), поэтому атлас грузится только сжатым путём — транскодер обязателен.
const atlasResource = (name, path) => ({
  name,
  path: `${path}.json`,
  ktxPath: `${path}.ktx2`,
  isTPSpriteAtlas: true,
});

// RU: папки спайнов символов по номеру: 1–8 — обычные символы, 9 — wild (звезда). Scatter нет.
const SYMBOL_FOLDERS = {
  1: 'symbol1',
  2: 'symbol2',
  3: 'symbol3',
  4: 'symbol4',
  5: 'symbol5',
  6: 'symbol6',
  7: 'symbol7',
  8: 'symbol8',
  9: 'wild',
};

const GAMBLE_ASSETS = 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture';

const atlases = (gameName, platform) => [
  atlasResource('infoSection', `game/${gameName}/images/${platform}/infoSection`),
  atlasResource('gameImages', `game/${gameName}/images/${platform}/gameImages`),
];

const sceneSpines = (gameName, platform) => [
  ...Object.entries(SYMBOL_FOLDERS).map(([id, folder]) =>
    spineResource(
      slotBarSymbolNames[`icon${id}`],
      `game/${gameName}/slotCharacters/${platform}/${folder}/${folder}`
    )
  ),
  spineResource(slotSpineKey.gameLogo, `game/${gameName}/logo/${platform}/Logo`),
  // RU: спайн фона — ресурс игры: ядро рисует его по `bgConfigs.resourceKey` (по умолчанию
  //     `mainBg`), но не грузит (0bdf1a8c). Риг — `mainBg` frame-пака, папка по платформе.
  spineResource('mainBg', `frame/frameModuleResources/main/mainBg/${platform}/background`),
  spineResource(slotSpineKey.winLine, `game/${gameName}/line/${platform}/line`),
  spineResource(slotSpineKey.reSpinText, `game/${gameName}/reSpinText/${platform}/respin`),
  spineResource(slotSpineKey.gambleAmountFrame, `${GAMBLE_ASSETS}/${platform}/amountFrame/amount`),
  spineResource(slotSpineKey.gambleCard, `${GAMBLE_ASSETS}/${platform}/card/card`),
  spineResource(slotSpineKey.gambleSymbol, `${GAMBLE_ASSETS}/${platform}/symbol/symbol`),
  // RU: спайн Big Win ядро рисует, но не грузит — его объявляет игра (MIGRATION-CLASSIC §2.1).
  spineResource(
    slotSpineKey.winPopup,
    `frame/frameModuleResources/main/winPopup/${platform}/PopUps`
  ),
];

// RU: bitmap-шрифта суммы Big Win (`winPopupNumbers`) здесь нет намеренно: его грузит frame-пак
//     ядра раньше ресурсов игры, повторная регистрация лишь пишет «already has key».

export const gameResources = (gameName) => {
  const platform = platformFolder();
  return [...atlases(gameName, platform), ...sceneSpines(gameName, platform)];
};
